import { render, staticRenderFns } from "./product-group-proList.vue?vue&type=template&id=e18cbe5e&scoped=true&"
import script from "./product-group-proList.vue?vue&type=script&lang=js&"
export * from "./product-group-proList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18cbe5e",
  null
  
)

export default component.exports